import { render, staticRenderFns } from "./CanvasLogo.vue?vue&type=template&id=851b4ab0&scoped=true&"
import script from "./CanvasLogo.vue?vue&type=script&lang=js&"
export * from "./CanvasLogo.vue?vue&type=script&lang=js&"
import style0 from "./CanvasLogo.vue?vue&type=style&index=0&id=851b4ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851b4ab0",
  null
  
)

export default component.exports